import { render, staticRenderFns } from "./PostClearanceEditButton.vue?vue&type=template&id=5d57306e&scoped=true&"
import script from "./PostClearanceEditButton.vue?vue&type=script&lang=js&"
export * from "./PostClearanceEditButton.vue?vue&type=script&lang=js&"
import style0 from "./PostClearanceEditButton.vue?vue&type=style&index=0&id=5d57306e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d57306e",
  null
  
)

export default component.exports